import { createContext, useContext } from "react";

export const EnquiryContext = createContext({ openEnquiry: () => {}, closeEnquiry: () => {} });
export const useEnquiry = () => useContext(EnquiryContext);
